import React from 'react'
import { contact } from '../data/Data'
import { Link } from 'react-router-dom'
// import img from "../../../public/images/socials/whatsapp.png"

function ContactCard() {
  return (
    <>
      <div className="content">
        {contact.map((items, index) => (
            <div className="box" key={index}>
                <h4><i className={items.icon}></i> {items.name}</h4>
                <div className="links">
                <Link to={items.link}>{items.details}</Link>
                </div>
                
            </div>
        ))} 
      </div>
      
    </>
  )
}

export default ContactCard